import React from "react";
import { createPortal } from "react-dom";

import Tooltip from "components/Tooltip";

const InsightsHeaderTooltips = () =>
    createPortal(
        <div id="insights-header-tooltips">
            <Tooltip id="drawingTip" />
            <Tooltip id="photoGalleryTip" />
            <Tooltip id="versionHistoryTip" />
            <Tooltip id="insightsTagTip" />
            <Tooltip id="reviewProgressTip" />
            <Tooltip id="saveTip" />
        </div>,
        document.body
    );

export default InsightsHeaderTooltips;
